"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var crypto_js_1 = require("crypto-js");
var DataCrypt = /** @class */ (function () {
    function DataCrypt() {
    }
    /**
     * Encrypt given text using given key
     * @param baseKey Key used for encryption. This key will be hashed and then used for encryption
     * @param text Text to be encrypted
     * @returns Encrypted text
     */
    DataCrypt.encryptPassword = function (baseKey, text) {
        var hashedValue = crypto_js_1.MD5(baseKey).toString().toUpperCase();
        var vectorLen = hashedValue.length / 2;
        var key = crypto_js_1.enc.Utf8.parse(hashedValue);
        var iv = crypto_js_1.enc.Utf8.parse(hashedValue.substring(0, vectorLen)); // Take this number from md5 of exp / 2
        var encryptedText = crypto_js_1.AES.encrypt(crypto_js_1.enc.Utf8.parse(text), key, {
            keySize: 128 / 4,
            iv: iv,
            mode: crypto_js_1.mode.CBC,
            padding: crypto_js_1.pad.Pkcs7
        });
        return encryptedText.toString();
    };
    return DataCrypt;
}());
exports.DataCrypt = DataCrypt;
//# sourceMappingURL=DataCrypt.js.map